import { render } from "./Project3View.vue?vue&type=template&id=2ee838d2&scoped=true"
import script from "./Project3View.vue?vue&type=script&lang=js"
export * from "./Project3View.vue?vue&type=script&lang=js"

import "./Project3View.vue?vue&type=style&index=0&id=2ee838d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ee838d2"]])

export default __exports__